import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DestinationsComponent } from './destinations/destinations.component';
import { DestinationComponent } from './destinations/destination/destination.component';
import { AdminComponent } from './admin/public-api';
import { adminRoutes } from './admin/admin.routes';
import { ArticleComponent } from './articles/article/article.component';
import { ArticlesComponent } from './articles/articles.component';
import { ArticleCategory, ArticleType } from './admin/shared/public-api';
import { ContactComponent } from './contact/contact.component';
import { EbookComponent } from './ebooks/ebook/ebook.component';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { MapComponent } from './map/map.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { RoadTripArticlesComponent } from './articles/roadtrip-articles.component';
import { BelgiumArticlesComponent } from './articles/belgium-articles.component';

export const routes: Routes = [
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: adminRoutes,
  },
  { path: 'admin/article/:articleSlug/preview', component: ArticleComponent },
  {
    path: 'articles',
    component: ArticlesComponent,
    data: {
      name: 'Articles',
      title: `Nos derniers articles - Les Explorateurs du monde`,
      articleType: ArticleType.Article,
      h1: 'Nos derniers articles',
      description: `Voici la liste de nos derniers articles, tu peux t'en inspirer pour préparer tes prochains voyages, ou simplement découvrir de nouvelles pépites !`,
    },
  },
  {
    path: 'belgique/roadtrip',
    component: BelgiumArticlesComponent,
    data: {
      name: `Roadtrip`,
      title: `Road trips en Belgique - Les Explorateurs du monde`,
      articleType: ArticleType.Article,
      h1: 'Nos road trips en Belgique',
      description: `Voici la liste de nos road trips en Belgique, tu peux t'en inspirer pour préparer tes prochains voyages, ou simplement découvrir de nouvelles pépites !`,
      category: ArticleCategory.RoadTrip,
    },
  },
  {
    path: 'belgique/citytrip',
    component: BelgiumArticlesComponent,
    data: {
      name: `Roadtrip`,
      title: `City trips en Belgique - Les Explorateurs du monde`,
      articleType: ArticleType.Article,
      h1: 'Nos city trips en Belgique',
      description: `Voici la liste de nos city trips en Belgique, tu peux t'en inspirer pour préparer tes prochains voyages, ou simplement découvrir de nouvelles pépites !`,
      category: ArticleCategory.CityTrip,
    },
  },
  {
    path: 'belgique/randonnees',
    component: BelgiumArticlesComponent,
    data: {
      name: `Roadtrip`,
      title: `Randonnées en Belgique - Les Explorateurs du monde`,
      articleType: ArticleType.Article,
      h1: 'Nos randonnées en Belgique',
      description: `Voici la liste de nos randonnées en Belgique, tu peux t'en inspirer pour préparer tes prochaines excursions, ou simplement découvrir de nouvelles pépites !`,
      category: ArticleCategory.Hiking,
    },
  },
  {
    path: 'carte',
    component: MapComponent,
    data: { name: 'Carte', title: `Nos explorations sur une carte - Les Explorateurs du monde` },
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: { name: 'Contact', title: `Contacte-nous! - Les Explorateurs du monde` },
  },
  {
    path: `destinations`,
    component: DestinationsComponent,
    data: { name: `Destinations`, title: `Nos destinations - Les Explorateurs du monde` },
  },
  {
    path: 'destination/:country',
    component: DestinationComponent,
    data: { name: 'Country: $replace', title: '$replace - Les Explorateurs du monde' },
  },
  {
    path: 'ebooks/:ebook',
    component: EbookComponent,
  },
  {
    path: 'legal-notice',
    component: LegalNoticeComponent,
    data: { name: 'Legal Notice', title: `Mentions Légales - Les Explorateurs du monde` },
  },
  {
    path: `logements`,
    component: ArticlesComponent,
    data: {
      name: `Logements`,
      title: `Logements - Les Explorateurs du monde`,
      articleType: ArticleType.Accommodation,
      h1: 'Nos logements',
      description: `Voici la liste des logements insolite ou non que nous avons visité, de quoi trouver un hébergement original et unique!`,
    },
  },
  {
    path: `materiel`,
    component: ArticlesComponent,
    data: {
      name: `Matériel`,
      title: `Notre matériel - Les Explorateurs du monde`,
      articleType: ArticleType.Setup,
      h1: 'Notre matériel',
      description: `Voici les différents équipements que nous utilisons pour nos voyages`,
    },
  },
  {
    path: 'roadtrip',
    component: RoadTripArticlesComponent,
    data: {
      title: 'Roadtrips - Les Explorateurs du monde',
      articleType: ArticleType.Article,
    },
  },
  {
    path: 'roadtrip/:country',
    component: RoadTripArticlesComponent,
    data: {
      title: 'Roadtrips - Les Explorateurs du monde',
      articleType: ArticleType.Article,
    },
  },
  {
    path: 'unsubscribe/:contactId',
    component: UnsubscribeComponent,
    data: {
      name: `Se désinscrire`,
      title: `Les Explorateurs du Monde - Blog voyages et découvertes belge`,
    },
  },
  {
    path: ':articleSlug',
    component: ArticleComponent,
    data: { name: '$replace', title: '$replace' },
  },
  {
    path: '',
    component: HomeComponent,
    data: { name: 'Home', title: `Les Explorateurs du Monde - Blog voyages et découvertes belge` },
  },
  // { path: '**', redirectTo: '404', pathMatch: 'full' },
];
